export enum TranslationEnum {
  Translation,
  TranslationForm,
}
